import { SmsUsaRegistrationStatus } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Tag } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';

interface RegistrationHeadingStatusProps {
    registrationStatus: SmsUsaRegistrationStatus;
    onRegisterClick: () => void;
}

export const RegistrationHeadingStatus = ({ onRegisterClick, registrationStatus }: RegistrationHeadingStatusProps) => {
    switch (registrationStatus) {
        case SmsUsaRegistrationStatus.BrandRegistrationNone: {
            return (
                <Button onClick={onRegisterClick} variant="ghost" icon={IconName.PlusSimple} type="button">
                    <LocalizedText textKey={TextKey.Register} />
                </Button>
            );
        }
        case SmsUsaRegistrationStatus.CampaignRegistrationVerified: {
            return (
                <Tag variant="success">
                    <LocalizedText textKey={TextKey.Approved} upperCase />
                </Tag>
            );
        }
        default:
            return null;
    }
};
